<script type="text/ecmascript-6">
import GeneralMixin from "JS/mixins/campaign/general";

export default {
  name: "SignaturesCounter",
  mixins: [GeneralMixin],
  props: {
    signatures: {
      required: true,
      type: Object
    }
  },
  inject: {
    eventsBus: { from: "eventsBus" }
  }
};
</script>
